import { tryFetch, type HttpResponse } from '@/services/http'
import { HttpMethod } from '@/services/http/types/http.enums'
import { FilterErrorCode } from '../models/filter.enums'
import type { FilterResponse } from '../models/filter.model'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getFilterSelection = async (): Promise<HttpResponse<FilterResponse, FilterErrorCode>> =>
  await tryFetch<FilterResponse, FilterErrorCode>(HttpMethod.Get, BASE_URL, 'filter/selection', {
    view: true,
  })

export const filterApi = {
  getFilterSelection,
}
